import { ActionConfigAbstract } from '../../services/actions/abstracts/action-config.abstract';
import { FieldModel } from '../../services/actions/models/field.model';

export class TermsActionConfig extends ActionConfigAbstract {
  protected readonly key: string = 'AffiliateCrm\\AffiliateDocuments\\Insert';
  protected readonly repository: string = 'Eloquent\\AffiliateDocumentsRepository';
  protected readonly title: string = '';
  protected readonly description: string = '';
  protected readonly fields: FieldModel[] = [];
}
